import { combineReducers } from 'redux';

import loanExceptionsByLoan from './loanExceptionsByLoan.reducer';

export default combineReducers({
  loanExceptionsByLoan,
});
